/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import type { LazyModal } from '@freelancer/ui/modal';

export const componentsModals: { [k: string]: LazyModal } = {
  AiCloseModal: {
    loadComponent: () =>
      import('@freelancer/components/ai-modal/ai-close-modal.component').then(
        m => m.AiCloseModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/components/ai-modal/ai-close-modal.module').then(
        m => m.AiCloseModalModule,
      ),
  },
  AiModal: {
    loadComponent: () =>
      import('@freelancer/components/ai-modal/ai-modal.component').then(
        m => m.AiModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/components/ai-modal/ai-modal.module').then(
        m => m.AiModalModule,
      ),
  },
  CustomBannerPopUpModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.component'
      ).then(m => m.CustomBannerPopUpModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/custom-banner/pop-up-modal/custom-banner-pop-up-modal.module'
      ).then(m => m.CustomBannerPopUpModalModule),
  },
  ShareModal: {
    loadComponent: () =>
      import('@freelancer/components/share-modal/share-modal.component').then(
        m => m.ShareModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/components/share-modal/share-modal.module').then(
        m => m.ShareModalModule,
      ),
  },
  ShowcaseSelectorModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/showcase-selector-modal/showcase-selector-modal.component'
      ).then(m => m.ShowcaseSelectorModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/showcase-selector-modal/showcase-selector-modal.module'
      ).then(m => m.ShowcaseSelectorModalModule),
  },
  UserFeedbackModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.component'
      ).then(m => m.UserFeedbackModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/user-feedback/user-feedback-modal/user-feedback-modal.module'
      ).then(m => m.UserFeedbackModalModule),
  },
  VideoRecordModal: {
    loadComponent: () =>
      import(
        '@freelancer/components/video-record-modal/video-record-modal.component'
      ).then(m => m.VideoRecordModalComponent),
    loadModule: () =>
      import(
        '@freelancer/components/video-record-modal/video-record-modal.module'
      ).then(m => m.VideoRecordModalModule),
  },
};
